/**
 * Open banking coverage — single source of truth (Feb 2026).
 *
 * Kept in lock-step with backend `services/billing_plans.py::OPEN_BANKING_COUNTRIES`.
 * Any surface that swaps copy between "connect your bank" and "import a
 * statement" MUST read from this constant so users in unsupported
 * regions never receive contradictory guidance.
 *
 * The set is intentionally small — only ISO-3166 alpha-2 country codes
 * where our Plaid (US) or Mono (NG) pipelines are live today. Expanding
 * coverage requires (a) a working provider and (b) updating the backend
 * constant first, then bumping this list.
 */
export const OPEN_BANKING_COUNTRIES = ['NG', 'US'];

/** True when the tenant's country has a live open-banking pipeline. */
export const isOpenBankingCountry = (country) => {
  if (!country) return false;
  return OPEN_BANKING_COUNTRIES.includes(String(country).toUpperCase());
};
